import Vue from 'vue'
import App from './App.vue'
import localforage from 'localforage'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import Dayjs from 'vue-dayjs'
import * as locale from 'dayjs/locale/pl'
import VueMeta from 'vue-meta'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration, CaptureConsole } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

(async() => {
    if(process.env.VUE_APP_SENTRY_KEY && process.env.VUE_APP_MODE) {
        Sentry.init({
            dsn: process.env.VUE_APP_SENTRY_KEY,
            environment: process.env.VUE_APP_MODE,
            release: process.env.PACKAGE_NAME + '@' + process.env.PACKAGE_VERSION,
            integrations: [
                new VueIntegration({
                    Vue,
                    tracing: true,
                    logErrors: true
                }),
                new Integrations.BrowserTracing(),
                new CaptureConsole({
                    levels: ['error']
                })
            ],
            tracesSampleRate: 1
        })
    } else {
        console.error('No Sentry key environment variable or env mode environment variable.')
    }

    Vue.config.productionTip = false

    // register styles
    require('./styles/main.sass')

    // register global components
    const globalComponents = require.context('./components/global', true, /\.vue$/i)
    globalComponents.keys().map(key => {
        Vue.component(globalComponents(key).default.name ?? key.split('/').pop().split('.')[0], globalComponents(key).default)
    })

    // plugins
    Vue.use(VueScrollTo)
    Vue.use(Dayjs, {
        lang: locale
    })
    Vue.use(VueMeta, {
        refreshOnceOnNavigation: true
    })
    // save vuex init state
    const initialState = store.state

    await localforage.setItem('initialState', initialState)

    // register Vue instance
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')

    // register service worker
    if('serviceWorker' in navigator) {
        if (process.env.VUE_APP_MODE !== 'development') {
            navigator.serviceWorker.register(
                `${process.env.BASE_URL}service-worker.js`
            )
        }
    }

    window.OneSignal = window.OneSignal || []
    window.OneSignal.push(() => {
        window.OneSignal.init({
            appId: process.env.VUE_APP_ONESIGNAL,
            allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production'
        })
    })

    // Add google map script if not exist; if exist, return true
    window.checkAndAttachMapScript = function (callback) {
        if (window.google !== undefined) {
            callback()
            return true
        }

        window.mapApiInitialized = callback
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&libraries=visualization&callback=mapApiInitialized`
        document.body.appendChild(script)
    }
})()
